<template>
  <div id="sidebar">
    <widget headline="Aktuelles">
      <p>{{this.aktuelles}}</p>
    </widget>
    <widget headline="Öffnungszeiten">
      <table id="table">
        <tr v-for="tag in oeffnungszeiten" :key="tag.tag + tag.zeit">
          <td v-for="item in tag" :key="item" class="item">
            <template v-for="line in item.split('\n')">
              {{line}}
              <br :key="line">
            </template>
          </td>
        </tr>
      </table>
    </widget>
    <widget headline="Kontakt">
      <div class="kontakt">
        <p v-for="item in kontakt" :key="item.type">{{ item.type }}: {{ item.value}}</p>
      </div>
    </widget>
    <widget headline="Adresse">
      <p v-html="this.addresse"></p>
    </widget>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Widget from "@/components/Widget";

export default {
  data() {
    return {};
  },
  created(){
    this.$store.dispatch("fetchAktuelles")
  },
  computed: {
    ...mapState(["kontakt", "oeffnungszeiten", "addresse", "aktuelles"])
  },
  components: {
    Widget
  }
};
</script>

<style lang="scss">
#sidebar {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;

  .card {
    flex-grow: 1;
  }
}
</style>
